import { alpha, useTheme } from "@mui/material";
import React from "react";

const DialogContainer = ({
  children,
  close,
}: {
  children: React.ReactNode;
  close: () => void;
}) => {
  const theme = useTheme();
  const backdropColor = alpha(theme?.palette?.primary?.main, 0.21);
  return (
    <div className="bc-fixed bc-z-50 bc-inset-0 bc-flex bc-items-center bc-justify-center bc-overflow-hidden">
      <div className="bc-fixed bc-inset-0 bc-transition-opacity">
        <div
          className="bc-absolute !bc-flex bc-inset-0"
          style={{ backgroundColor: backdropColor }}
          onClick={close}
        ></div>
      </div>
      {children}
    </div>
  );
};

export default DialogContainer;
